import { Ingredient } from '../types/content.type';

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;

const stripIngredientHtml = (name: string): string =>
  name
    .replace(/<[^>]+>/g, '')
    .replace(/\*\*/g, '')
    .trim();

export const getIngredientLabels = (ingredients: Ingredient[]): string[] => {
  const labels = new Set<string>();

  ingredients.forEach((ingredient) => {
    const beforeParen = stripIngredientHtml(ingredient.name).split('(')[0].trim();
    const withoutQuantity = beforeParen
      .replace(/^[\d/.]+\s*(?:\d+\/\d+\s*)?(?:C|T|pinches?|cups?|tablespoons?|teaspoons?|lbs?\.?)\s+/i, '')
      .trim();

    if (withoutQuantity.length >= 4) {
      labels.add(withoutQuantity);
    }

    if (withoutQuantity.includes(',')) {
      const shortName = withoutQuantity.split(',')[0].trim();
      if (shortName.length >= 4) {
        labels.add(shortName);
      }
    }
  });

  return [...labels].sort((a, b) => b.length - a.length);
};

export const boldIngredientMentions = (content: string, ingredientLabels: string[]): string => {
  if (!content || HTML_TAG_PATTERN.test(content) || !ingredientLabels.length) {
    return content;
  }

  let result = content;

  ingredientLabels.forEach((label) => {
    const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    result = result.replace(
      new RegExp(`(?<!\\*\\*)\\b(${escaped})\\b(?!\\*\\*)`, 'gi'),
      '**$1**'
    );
  });

  return result;
};
